/**
 * tse:diagnosis_prompt banner (tse_diagnosis_prompt.schema.json): the small "switch to automatic" offer
 * after two denials of the pinned cause. Offered, never forced: the pending question stays answerable.
 * Confirm / dismiss send tse:action commands with params.prompt_id (brainCommands.promptCommand); the
 * row then waits for tse:command_result and disappears once answered or replaced by a newer prompt.
 */
import React from "react";
import { Zap } from "lucide-react";

const ICON_SIZE = 14;
export const PROMPT_STATUS = Object.freeze({ OPEN: "open", PENDING: "pending", DONE: "done", SUPERSEDED: "superseded" });

export default function DiagnosisPromptBanner({ msg, disabled = false, onConfirm, onDismiss }) {
  if (msg.status === PROMPT_STATUS.DONE || msg.status === PROMPT_STATUS.SUPERSEDED) return null;
  const pending = msg.status === PROMPT_STATUS.PENDING;
  const off = disabled || pending;
  return (
    <div className="d5-dxprompt-row" data-testid="diagnosis-prompt-row" data-prompt-id={msg.id} aria-busy={pending || undefined}>
      <span className="d5-dxprompt-icon" aria-hidden="true"><Zap size={ICON_SIZE} /></span>
      <span className="d5-dxprompt-text">{msg.text}</span>
      <span className="d5-dxprompt-actions">
        <button type="button" className="d5-dxprompt-btn" disabled={off} onClick={() => onConfirm?.(msg)}>
          {msg.confirm_label}
        </button>
        <button type="button" className="d5-dxprompt-btn d5-dxprompt-btn--ghost" disabled={off} onClick={() => onDismiss?.(msg)}>
          {msg.dismiss_label}
        </button>
      </span>
    </div>
  );
}
